import React from "react";
import styled from "styled-components";
import Query from "./Query";
import Results from "./Results";

const Wrapper = styled.div`
  position: relative;
  flex: 1;
  margin-right: 10px;
`;

type Props = {};

const Search: React.FC<Props> = props => {
  return (
    <Wrapper>
      <Query />
      <Results />
    </Wrapper>
  );
};

export default Search;
